import { __spreadArray, __read, __assign } from '../node_modules/tslib/tslib.es6.esm.js';

var _a;
var DATE_RANGE_SEPARATOR = ' - ';
var NUMBERS_IN_DATE_MASK = 8;
var DEFAULT_MASK_CHAR = '_';
var singleDateMasks = ['DD/MM/YYYY', 'MM/DD/YYYY', 'YYYY/MM/DD'];
var dateRangeMasks = [
    "DD/MM/YYYY".concat(DATE_RANGE_SEPARATOR, "DD/MM/YYYY"),
    "MM/DD/YYYY".concat(DATE_RANGE_SEPARATOR, "MM/DD/YYYY"),
    "YYYY/MM/DD".concat(DATE_RANGE_SEPARATOR, "YYYY/MM/DD"),
];
var dateMasks = __spreadArray(__spreadArray([], __read(singleDateMasks), false), __read(dateRangeMasks), false);
var dateMaskTypes = (_a = {},
    _a['DD/MM/YYYY'] = '99/99/9999',
    _a["DD/MM/YYYY".concat(DATE_RANGE_SEPARATOR, "DD/MM/YYYY")] = "99/99/9999".concat(DATE_RANGE_SEPARATOR, "99/99/9999"),
    _a['MM/DD/YYYY'] = '99/99/9999',
    _a["MM/DD/YYYY".concat(DATE_RANGE_SEPARATOR, "MM/DD/YYYY")] = "99/99/9999".concat(DATE_RANGE_SEPARATOR, "99/99/9999"),
    _a['YYYY/MM/DD'] = '9999/99/99',
    _a["YYYY/MM/DD".concat(DATE_RANGE_SEPARATOR, "YYYY/MM/DD")] = "9999/99/99".concat(DATE_RANGE_SEPARATOR, "9999/99/99"),
    _a);
var otherMaskTypes = {
    phoneAU: '+61 9999 999 999',
    phoneBR: '+55 99999-9999',
    phoneCA: '+1 (999) 999-9999',
    phoneIS: '+972 99 999-9999',
    phoneMX: '+52 999-999-9999',
    phoneUK: '+44 999 999999',
    phoneUS: '+1 (999) 999-9999',
};
var maskTypes = __assign(__assign({}, dateMaskTypes), otherMaskTypes);
var isDateMask = function (maybeDateMask) {
    return dateMasks.includes(maybeDateMask);
};
var isDateRangeMask = function (maybeDateMask) {
    return dateRangeMasks.includes(maybeDateMask);
};
var getInputMask = function (maskType) {
    if (!maskType)
        return '';
    if (Object.keys(maskTypes).includes(maskType)) {
        return maskTypes[maskType];
    }
    return maskType;
};

export { DATE_RANGE_SEPARATOR, DEFAULT_MASK_CHAR, NUMBERS_IN_DATE_MASK, getInputMask, isDateMask, isDateRangeMask, maskTypes, singleDateMasks };
//# sourceMappingURL=maskTypes.esm.js.map
